import PageListCtrl from '../PageListCtrl';

import newsfeedPagesRouteUrl from './newsfeed-pages-route.html';

export default {
  templateUrl: newsfeedPagesRouteUrl,
  controller: PageListCtrl,
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
};
